var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{ref:"notice",staticClass:"demo-environment-notice",style:(_vm.noticeStyle),on:{"mousedown":_vm.startDrag,"touchstart":_vm.startDrag}},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }